export default __webpack_public_path__ + "static/media/Photoshop.00b0d44a.png";